import gql from 'graphql-tag';

export default gql`
  mutation favoriteRemoveItem($id: ID!) {
    favoriteRemoveItem(id: $id) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
